import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-floating, floating-window"} maskId="square-filled-radius-0-stroke-1-IconSidebarFloating"><path fillRule="evenodd" clipRule="evenodd" d="M22 4V20H2V4H22ZM15 11V17H19V11H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarFloating;
